import React from 'react';
import { parseCSV } from 'highed';
import Button from '../../../shared/buttons/Button';

class CreateTable extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      rows: 5,
      columns: 5,
      selectedRows: null,
      selectedColumns: null,
      maxColumns: 25,
      maxRows: 25,
    };

    this.create = this.create.bind(this);
    this.handleOnMouseOver = this.handleOnMouseOver.bind(this);
  }

  componentWillReceiveProps(newProps) {}

  create() {
    const { selectedRows, selectedColumns } = this.state;
    let dataOptions = [...Array(selectedRows + 1)].map((x, rowCount) => [...Array(selectedColumns + 1).fill('')]);
    dataOptions[0].forEach((data, i) => {
      dataOptions[0][i] = 'Header ' + (i + 1);
    });

    this.props.setData(dataOptions, this.props.customizedOptions);
  }

  handleOnMouseOver(e) {
    const { rows, columns, maxColumns, maxRows } = this.state;

    let state = {
      selectedColumns: parseInt(e.target.getAttribute('data-value')),
      selectedRows: parseInt(e.target.parentNode.getAttribute('data-value')),
    };

    if (state.selectedColumns === columns - 1) {
      state.columns = columns + 1;
    }

    if (state.selectedRows === rows - 1) {
      state.rows = rows + 1;
    }
    if (state.rows > maxRows) state.rows = maxRows;
    if (state.columns > maxColumns) state.columns = maxColumns;

    this.setState(state);
  }

  render() {
    const { rows, columns, selectedRows, selectedColumns } = this.state;
    return (
      <div className="create-table-widget" onClick={this.create}>
        {[...Array(rows)].map((x, rowCount) => {
          return (
            <div className="create-table-row " key={'create_table_row_' + rowCount} data-value={rowCount}>
              {[...Array(columns)].map((x, columnCount) => {
                return (
                  <div
                    key={'create_table_column_' + columnCount}
                    className={
                      'create-table-column ' +
                      (rowCount <= selectedRows && columnCount <= selectedColumns ? 'active' : '')
                    }
                    onMouseOver={this.handleOnMouseOver}
                    data-value={columnCount}
                  />
                );
              })}
            </div>
          );
        })}
        {selectedRows !== null && selectedColumns !== null && (
          <div className="rows-column-indicator">
            {selectedColumns + 1}x{selectedRows + 1}
          </div>
        )}
      </div>
    );
  }
}

CreateTable.propTypes = {};

export default CreateTable;
